/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const factory = (Model, LedgerCategoryCollection, MainappActions, $rootScope) => {
  class Ledger extends Model {
    $postUrl() {
      return `${this.$resource}.json`;
    }
    $baseUrl() {
      return this.$url(this.$storeId());
    }

    // overrides to prevent usage
    $fetch() {}

    $post(...args) {
      return super.$post(...(args || [])).then(res => {
        $rootScope.$emit(MainappActions.ledgerChanged());
        return res;
      });
    }

    $put(...args) {
      return super.$put(...(args || [])).then(res => {
        $rootScope.$emit(MainappActions.ledgerChanged());
        return res;
      });
    }

    $serialize(data) {
      return Object.assign({}, data, { isFunctional: data.role != null });
    }

    $deserialize(data) {
      const ledgerCategoryCollection = new LedgerCategoryCollection();

      return Object.assign({}, data, {
        isFunctional: undefined,
        role: data.isFunctional ? ledgerCategoryCollection.getRoleName(data.categoryId) : null,
      });
    }

    $reorderTo(reorderId, isLast) {
      return this.$apiCall({
        method: 'PUT',
        url: `${this.$baseUrl()}/reorder_to/${reorderId}/${isLast}`,
      });
    }

    $isAccount() {
      return this.role != null;
    }
  }
  Ledger.prototype.$resource = 'ledgeraccount';
  Ledger.prototype.id = null;
  Ledger.prototype.code = null;
  Ledger.prototype.categoryId = '1';
  Ledger.prototype.currencyId = '2';
  Ledger.prototype.clientId = null;
  Ledger.prototype.role = 'BANK_ACCOUNT';
  Ledger.prototype.name = '';
  Ledger.prototype.accountType = 'FLAVOUR';
  Ledger.prototype.canBeEdited = null;
  Ledger.prototype.canInfoBeEdited = null;
  Ledger.prototype.canDeleteCauseConflict = null;
  Ledger.prototype.canBeHidden = null;
  Ledger.prototype.canBeDeleted = null;
  Ledger.prototype.hasTransactions = null;
  Ledger.prototype.canTransfer = null;
  Ledger.prototype.order = null;
  Ledger.prototype.version = null;
  Ledger.prototype.isAddOn = null;
  Ledger.prototype.details = null;
  Ledger.prototype.statementDayOfMonth = null;
  Ledger.prototype.active = true;
  Ledger.prototype.isFunctional = false;
  Ledger.prototype.accountSettings = { volume: 'MEDIUM' };
  Ledger.prototype.autoPostEnabled = true;
  Ledger.prototype.financialInstitutionProductId = null;
  Ledger.prototype.isTemporary = false;

  Ledger.volumeLabels = {
    LOW: 'Low',
    MEDIUM: 'Medium',
    HIGH: 'High',
    VERY_HIGH: 'Very High',
    NOT_APPLICABLE: 'N/A',
  };

  Ledger.volumeKeys = _.keys(Ledger.volumeLabels);

  return Ledger;
};

const moduleDeps = [
  require('data/util').name,
  require('data/collection/ledgerCategory').name,
  require('data/actions/mainapp').name,
];

module.exports = angular.module('bench.data.model.ledger', moduleDeps).factory('Ledger', factory);
